import loader from "../../styles/loader.css"

const ClassicSpinner=()=>{
    return(
        <div class="loader w-full "></div> 
    )
}

export default ClassicSpinner